import { createError } from './createError';

export const notSupportedError = (message = 'The operation is not supported') => {
    return createError(message, 'NotSupportedError');
};
